<template>
  <transition name="fade">
    <v-overlay v-show="loader">Cargando </v-overlay>
    <v-form ref="prodForm">
      <v-autocomplete
        v-model="productoData.Tipo"
        :items="tiposProducto"
        label="Tipo de producto"
        @change="$forceUpdate()"
        :rules="rules.Tipo"
        disabled
        item-value="id"
        item-text="name"
      >
      </v-autocomplete>
      <v-text-field
        v-model="productoData.Nombre"
        :rules="rules.Nombre"
        label="Nombre del producto"
      >
      </v-text-field>
      <v-text-field
        v-model="productoData.Marca"
        :rules="rules.Marca"
        label="Marca del producto"
      />
      <v-autocomplete
        multiple
        v-model="productoData.Departamentos"
        :rules="rules.Departamento"
        label="Departamento"
        :items="modulos"
      >
      </v-autocomplete>
      <v-autocomplete
        v-model="productoData.Categoria"
        label="Categoría del producto"
        :items="categoriesList"
        :rules="rules.Categoria"
        item-value="id"
        item-text="label"
      >
      </v-autocomplete>

      <v-text-field
        v-if="!edit"
        v-model="productoData.Codigo"
        :rules="rules.Codigo"
        label="Codigo del producto"
      />
      <v-text-field
        v-if="productoData.Tipo == 'Producto-NInv'"
        v-model="productoData.Precio"
        :rules="rules.Precio"
        @keypress="$pgsHelper.onlyNumber($event, Precio)"
        label="Precio de Producto"
      >
      </v-text-field>
      <v-select
        v-if="productoData.Tipo == 'Producto-NInv'"
        v-model="productoData.Moneda"
        :rules="rules.Moneda"
        label="Tipo de moneda"
        item-value="id"
        item-text="Nombre"
        :items="monedas"
      >
      </v-select>
      <v-text-field
        v-if="false"
        v-model="productoData.CodigoSat"
        label="Codigo SAT (Opcional)"
      />
      <v-text-field
        v-model="productoData.Alerta"
        @keypress="$pgsHelper.onlyNumber($event, productoData.Alerta)"
        label="Minimo de productos para alertar de baja existencia"
      />
      <v-switch
        v-if="false"
        v-model="productoData.PrecioVariable"
        label="Precio Variable"
      />
      <v-text-field
        v-model="productoData.Orden"
        @keypress="$pgsHelper.onlyNumber($event, productoData.Orden)"
        label="Orden en el que aparecera dentro de la categoria"
      />
      <v-container>
        <v-card>
          <v-card-title class="headline">
            Detalle de Ingreso de Facturación
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-label>
                  Facturas en este documento: (Puedes seleccionar una de las
                  facturas registradas en el documento o buscar otra)
                </v-label>
                <v-chip-group>
                  <v-chip
                    v-for="(fact, index) in facturasDocument"
                    :key="index"
                    color="blue"
                    outlined
                    @click="selectExistFactura(fact)"
                  >
                    {{ fact.Nombre }} - {{ fact.ProvNombre }}
                  </v-chip>
                </v-chip-group>
              </v-col>

              <v-col cols="12" md="6">
                <v-label>Selecciona el proveedor para buscar facturas</v-label>
                <v-alert v-if="errors.factura" type="error" dense outlined>
                  {{ errors.factura }}
                </v-alert>
                <v-autocomplete
                  v-model="provedorSearch"
                  :items="comp_proveedor"
                  @update:search="searchProv"
                  label="Seleccione un proveedor para buscar facturas"
                  placeholder="Seleccione un proveedor"
                  dense
                  outlined
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="6">
                <v-label>Factura</v-label>
                <v-alert v-if="errors.factura" type="error" dense outlined>
                  {{ errors.factura }}
                </v-alert>
                <v-autocomplete
                  v-model="Factura"
                  :items="comp_fact"
                  @change="onSelectProv"
                  label="Seleccione una factura del listado"
                  placeholder="Seleccione una factura"
                  dense
                  outlined
                ></v-autocomplete>
              </v-col>

              <v-col cols="12">
                <v-label>¿No encuentras tu factura? {{ searchText }}</v-label>
                <v-btn
                  color="primary"
                  small
                  @click="
                    keyformFactura++;
                    showModalFactura = true;
                  "
                >
                  Agregar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
      <!-- <div v-if="false">
        <div class="content">
          <div class="header">Detalle de Ingreso de Facturación</div>
        </div>
        <div class="content">
          <div class="field">
            <label
              >Facturas en este documento: (Puedes seleccionar una de las facturas
              registradas en el documento o buscar otra)
            </label>
            <template v-for="(fact, index) in facturasDocument">
              <a
                href="javascript:void(0);"
                @click="selectExistFactura(fact)"
                :key="index"
                class="ui blue label"
                >{{ fact.Nombre }} - {{ fact.ProvNombre }}</a
              >
            </template>
          </div>
          <div class="field">
            <div class="field required">
              <label
                >Selecciona el proveedor para buscar facturas
                <v-alert v-if="errors.factura" type="error" dense outlined>
                  {{ errors.factura }}
                </v-alert>
              </label>
              <model-select
                :options="comp_proveedor"
                v-model="provedorSearch"
                @searchchange="searchProv"
                placeholder="Seleccione un proveedor para buscar facturas"
              >
              </model-select>
            </div>
          </div>
          <div class="field two fields">
            <div class="field required">
              <label
                >Factura
                <v-alert v-if="errors.factura" type="error" dense outlined>
                  {{ errors.factura }}
                </v-alert>
              </label>
              <model-select
                :options="comp_fact"
                v-model="Factura"
                @select="onSelectProv"
                placeholder="Seleccione una factura del listado"
              >
              </model-select>
            </div>
            <div class="field">
              <label>¿No encuentras tu factura? {{ searchText }} </label>
              <button
                type="button"
                @click="
                  keyformFactura++;
                  showModalFactura = true;
                "
                class="ui primary tiny button"
              >
                Agregar
              </button>
            </div>
          </div>
        </div>
      </div> -->
      <v-text-field
        v-model="precioCompra"
        @keypress="$pgsHelper.onlyNumber($event, precioCompra)"
        label="Precio compra"
      />
      <v-select
        v-model="monedaCompra"
        :rules="rules.Moneda"
        label="Moneda de compra"
        item-value="id"
        item-text="Nombre"
        :items="monedas"
      >
      </v-select>
      <v-text-field
        v-model="Precio"
        @keypress="$pgsHelper.onlyNumber($event, Precio)"
        label="Precio Venta"
      />
      <v-select
        v-model="Moneda"
        :rules="rules.Moneda"
        label="Moneda de venta"
        item-value="id"
        item-text="Nombre"
        :items="monedas"
      >
      </v-select>
      <v-text-field
        v-model="Existencia"
        @keypress="$pgsHelper.onlyNumber($event, Existencia)"
        label="Cantidad del producto que recibe"
      />
      <div class="text-right">
        <v-btn large @click="$emit('toggle', false)"> Cancelar </v-btn>
        <v-btn style="margin-left: 6px" color="success" large @click="checkForm"
          >Guardar</v-btn
        >
      </div>
    </v-form>
    <modal
      v-model="showModalFactura"
      :showFooter="false"
      title="Agregar nueva factura"
    >
      <FacturaForm
        :key="keyformFactura"
        @successData="saveFactura"
        @toggle="showModalFactura = false"
      ></FacturaForm>
    </modal>
  </transition>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<script>
import Producto from "../../../clases/Producto.js";
import Currency from "../../../clases/Currencies.js";
import moment from "moment";
import modal from "../../MainComponents/modal.vue";
import { ModelSelect } from "vue-search-select";
import FacturaForm from "../../Inventarios/RecepcionMercancias/FacturaForm.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ProductAddForm",
  components: {
    // ModelSelect,
    FacturaForm,
    modal,
  },
  props: ["edit", "dataEdit", "loadData", "facturasDocument"],
  data() {
    return {
      productoData: new Producto(),
      monedas: Currency.getCurrencies(),
      tiposProducto: Producto.getTiposProducto(),
      rules: Producto.getRules(),
      facturaNombre: "",
      proveedorNombre: "",
      precioCompra: "",
      monedaCompra: "USD",
      monedaVenta: "",
      searchText: "",
      provedorSearch: "",
      Nombre: "",
      Marca: "",
      Precio: "",
      Categoria: "",
      Orden: 0,
      Moneda: "MXN",
      Factura: "",
      keyformFactura: 1,
      showModalFactura: false,
      Categories: [],
      Departamento: "",
      errors: {},
      CodigoSat: "",
      Codigo: "",
      CodigoBarras: "",
      Existencia: "",
      Alerta: "",
      loader: true,
      facturasArray: [],
      proveedorArray: [],
    };
  },
  methods: {
    selectExistFactura(data) {
      this.facturasArray = [{ id: data.Id, Nombre: data.Nombre }];
      this.proveedorArray = [{ id: data.ProvId, Nombre: data.ProvNombre }];
      this.Factura = data.Id;
      this.provedorSearch = data.ProvId;
    },
    async searchProv(searchText) {
      if (searchText != "") {
        this.proveedorArray = [];
        const database = await this.$store.getters.getFirebaseApp.database;
        const data = await database.queryBuilder("AMC/Provedores", []);
        if (data.exists()) {
          let arrayFactura = Object.entries(data.val());
          this.$pgsHelper.log(arrayFactura);
          arrayFactura.forEach((element) => {
            this.proveedorArray.push({
              id: element[0],
              Nombre: element[1]["nom"],
            });
          });
        }
      }
    },
    async onSelectProv(item) {
      if (item != "") {
        this.facturasArray = [];
        let searchText = item.toUpperCase();
        const database = await this.$store.getters.getFirebaseApp.database;
        const data = await database.queryBuilder("PDV/Productos/Facturas", [
          database.orderByChild("PVDR_ID~~PVDR_NAME~~NAME"),
          database.startAt(searchText),
          database.endAt(searchText + "\uf8ff"),
        ]);

        if (data.exists()) {
          let arrayFactura = Object.entries(data.val());
          this.$pgsHelper.log(arrayFactura);
          arrayFactura.forEach((element) => {
            this.facturasArray.push({
              id: element[0],
              Nombre: element[1]["Nombre"],
              Proveedor: element[1]["ProvNombre"],
            });
          });
        }
      }
    },
    async searchProveedor(searchText) {
      if (searchText != "") {
        this.facturasArray = [];
        searchText = searchText.toUpperCase();
        this.$pgsHelper.log(searchText);
        const database = await this.$store.getters.getFirebaseApp.database;
        const data = await database.queryBuilder("PDV/Productos/Facturas", [
          database.orderByChild("NAME~~PVDR_NAME~~PVDR_ID"),
          database.startAt(searchText),
          database.endAt(searchText + "\uf8ff"),
        ]);
        if (data.exists()) {
          let arrayFactura = Object.entries(data.val());
          this.$pgsHelper.log(arrayFactura);
          arrayFactura.forEach((element) => {
            this.facturasArray.push({
              id: element[0],
              Nombre: element[1]["Nombre"],
              Proveedor: element[1]["ProvNombre"],
            });
          });
        }
      }

      /*let categorias = [];
        arrayCate.forEach(function(element){
            categorias.push({id:element[0],Nombre:element[1]['Nombre']}); 
        });
        this.Categories = categorias;*/
      //CONF/Catalogo/PDV/Productos/Facturas
    },
    saveFactura(datos) {
      let sendData = {
        Nombre: datos.factura,
        ProvId: datos.proveedor,
        ProvNombre: datos.proveedorNombre,
        Creacion: new moment().format("YYYY-MM-DD"),
      };
      this.$pgsHelper.log(sendData);
      this.$swal({
        title: "¿Deseas crear esta nueva factura?",
        text: "Se registrar la factura con los datos indicados ",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("ProShop-Productos-createFactura", sendData)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "La factura se guardo corretamente",
              icon: "success",
            });

            this.showModalFactura = false;
          } else {
            this.$swal(
              "Error saving Categoria",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      await this.fetchCategories();
      const claims = this.$route.params.user?.tokenResult?.claims;
      this.Categories = this.getCategoriesFiltered(claims);
    },
    checkForm: function (e) {
      e.preventDefault();
      let valid = true;

      this.errors = [];

      /*
        if (!this.HoraFinal) {
            this.errors.hfinal = 'La hora final es requerida';
            valid = false;
        }else{
            this.errors.hfinal = false;
        }*/

      if (valid) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.facturasArray.forEach((element) => {
          if (element.id == this.Factura) {
            this.facturaNombre = element.Nombre;
          }
        });

        this.proveedorArray.forEach((element) => {
          if (element.id == this.provedorSearch) {
            this.proveedorNombre = element.Nombre;
          }
        });
        (this.productoData.precioCompra = this.precioCompra),
          (this.productoData.monedaCompra = this.monedaCompra),
          (this.productoData.monedaCompra = this.monedaCompra),
          (this.productoData.Precio = this.Precio),
          (this.productoData.Moneda = this.Moneda),
          (this.productoData.Existencia = this.Existencia),
          (this.productoData.Factura = this.Factura),
          (this.productoData.facturaNombre = this.facturaNombre),
          (this.productoData.provedorSearch = this.provedorSearch),
          (this.productoData.proveedorNombre = this.proveedorNombre),
          this.$emit("successData", this.productoData, doAction);
      }
    },
  },
  computed: {
    ...mapGetters("Categorias", ["getCategoriesFiltered"]),
    comp_fact() {
      let fact = [];
      this.facturasArray.forEach((element) => {
        fact.push({
          value: element.id,
          text: element.Nombre + " - " + element.Proveedor,
        });
      });

      return fact;
    },

    comp_proveedor() {
      let prov = [];
      this.proveedorArray.forEach((element) => {
        prov.push({ value: element.id, text: element.Nombre });
      });

      return prov;
    },
    modulos() {
      let dep = [{ value: "", text: "Seleccione un modulo" }];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((element) => {
        dep.push({ value: element.id, text: element.Nombre });
      });
      return dep;
    },
    categoriesList() {
      let categories = [];
      if (this.productoData.Departamentos.length > 0) {
        this.Categories.forEach((categoria) => {
          this.productoData.Departamentos.forEach((modulo) => {
            if (modulo == categoria.Departamento) {
              categories.push(categoria);
            }
          });
        });
        return categories;
      } else {
        return this.Categories;
      }
    },
  },
  watch: {
    provedorSearch: function (val) {
      this.onSelectProv(val);
    },
  },
  beforeMount: function () {},
  mounted() {
    this.loader = false;
    this.getCategories();
    if (this.edit) {
      this.productoData = new Producto(this.dataEdit);
    }
    this.productoData.Tipo = "Producto";
  },
};
</script>
